// Lives in a .ts file so Fast Refresh isn't invalidated by mixed exports in the .tsx Provider.
import { createContext } from 'react';

export type FontSize = 'small' | 'medium' | 'large';

export interface FontSizeContextValue {
  fontSize: FontSize;
  setFontSize: (size: FontSize) => void;
  getFontSizeClass: () => string;
  getDashboardFontSizeClass: () => string;
}

export const FontSizeContext = createContext<FontSizeContextValue | undefined>(undefined);
